import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import SpareParameterForm from "components/spares/parameters/SpareParameterForm";
import { createSpareParameter } from "graphql/mutations";
import { getSpare, spareParametersBySpareID } from "graphql/queries";
import { Loader } from "@aws-amplify/ui-react";

const SpareParameterCreateForm = ({ spareID, onSuccess }) => {
  const navigate = useNavigate();
  const [companyID, setCompanyID] = useState("");
  const spareParameter = {
    parameterID: "",
    parameterValue: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { parameterID, parameterValue } = valuesParam;
      const oldSpareParameterData = await API.graphql(
        graphqlOperation(spareParametersBySpareID, {
          spareID,
          filter: {
            and: [
              {
                parameterID: { eq: parameterID },
              },
            ],
            deletedAt: { attributeExists: false },
          },
        })
      );
      const oldSpareParameterItems =
        oldSpareParameterData.data.spareParametersBySpareID.items;

      if (oldSpareParameterItems.length > 0) {
        toast.error(strings.parameterExists);
        return;
      }

      await API.graphql({
        query: createSpareParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            spareID,
            parameterID,
            parameterValue,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/spares");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function getCompanyFromSpare(id) {
    try {
      const spareData = await API.graphql(
        graphqlOperation(getSpare, { id })
      );
      const spareItem = spareData.data.getSpare;
      if (!spareItem) {
        toast.error(strings.responses.errorFetchSpare);
        return;
      }
      setCompanyID(spareItem.companyID);
    } catch (err) {
      toast.error(strings.responses.errorFetchSpare);
    }
  }

  useEffect(() => {
    getCompanyFromSpare(spareID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spareID]);

  if (!companyID) return <Loader />;

  return (
    <div>
      <SpareParameterForm
        onSubmit={onSubmit}
        initialValues={spareParameter}
        companyID={companyID}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Parámetro de Repuesto",
    successAdded: "Parámetro de Repuesto agregado con éxito",
    parameterExists: "El parámetro ya existe en el repuesto",
    responses: {
      errorFetchSpare: "Error al consultar repuesto",
    },
  },
});

export default SpareParameterCreateForm;
